import {IModalService, IModalSettings} from "angular-ui-bootstrap";
import {ChildOrdersDialog} from "../../components/child-orders-dialog/ChildOrdersDialogComponent";
import {EquityOrderWizardStore} from "../../../portfolio/templates/ticket/place-equity-order-wizard/store/EquityOrderWizardStore";
import {ChildOrder} from "../../../portfolio/templates/ticket/place-order-wizard/models/ChildOrder";

export class ChildOrdersService {

    public static readonly id = "childOrdersService";

    /** @ngInject */
    public constructor(private readonly $uibModal: IModalService) {
    }

    public open(store: EquityOrderWizardStore, childOrder: ChildOrder | null, index: number | null) {
        const options: IModalSettings = {
            size: "md",
            backdrop: "static",
            component: ChildOrdersDialog,
            resolve: {
                store: () => store,
                childOrder: () => childOrder,
                index: () => index
            }
        };
        this.$uibModal.open(options);
    }
}
